/**
 * Product Tabs - Simple & Clean
 */

document.addEventListener('DOMContentLoaded', function() {
  initProductTabs();
});

function initProductTabs() {
  const wrappers = document.querySelectorAll('.product-tabs-wrapper');
  
  wrappers.forEach(wrapper => {
    const buttons = wrapper.querySelectorAll('.tab-button');
    const contents = wrapper.querySelectorAll('.tab-content');
    const nav = wrapper.querySelector('.tabs-navigation');
    
    // Tab click handler
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab');
        
        // Remove active class
        buttons.forEach(btn => btn.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));
        
        // Add active class
        this.classList.add('active');
        const targetContent = wrapper.querySelector(`#${tabId}`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
        
        // Center tab in view
        centerTab(this, nav);
      });
    });
    
    // Center active tab on load
    const activeBtn = wrapper.querySelector('.tab-button.active');
    if (activeBtn) {
      setTimeout(() => centerTab(activeBtn, nav), 100);
    }
  });
}

function centerTab(button, nav) {
  const buttonLeft = button.offsetLeft;
  const buttonWidth = button.offsetWidth;
  const navWidth = nav.offsetWidth;
  const scrollPos = buttonLeft - (navWidth / 2) + (buttonWidth / 2);
  
  nav.scrollTo({
    left: scrollPos,
    behavior: 'smooth'
  });
}

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function() {
    initProductTabs();
  });
}